/**
 * Converts an image proxy URL to its thumbnail variant.
 *
 * Transforms:
 *   /api/v1/images/{bucket}/{key}   →  /api/v1/thumbnails/{bucket}/{key}
 *
 * The backend serves resized (max 200×200) JPEG thumbnails via the
 * /api/v1/thumbnails/ route, caching results in S3 at thumb/{key}.
 *
 * Only our own proxy URLs are transformed. External or presigned S3 URLs
 * are returned unchanged.
 */
export function toThumbnailUrl(url: string | null | undefined): string | null {
  if (!url) return null;
  const idx = url.indexOf('/api/v1/images/');
  if (idx === -1) return url;
  return url.slice(0, idx) + url.slice(idx).replace('/api/v1/images/', '/api/v1/thumbnails/');
}

/**
 * Converts a thumbnail URL back to the original full-resolution image URL.
 *
 * Transforms:
 *   /api/v1/thumbnails/{bucket}/{key}  →  /api/v1/images/{bucket}/{key}
 *
 * Use this when the full-resolution image is needed (e.g. zoom modal).
 * Non-thumbnail URLs are returned unchanged.
 */
export function toOriginalUrl(url: string | null | undefined): string | null {
  if (!url) return null;
  const idx = url.indexOf('/api/v1/thumbnails/');
  if (idx === -1) return url;
  return url.slice(0, idx) + url.slice(idx).replace('/api/v1/thumbnails/', '/api/v1/images/');
}
